import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Animated notification badge component
 * Displays unread count with pulse animation
 */
const NotificationBadge = ({ count = 0, className = '' }) => {
  // Don't render if count is 0
  if (!count || count <= 0) return null;

  // Format count (show 99+ for counts over 99)
  const displayCount = count > 99 ? '99+' : count;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ 
          scale: 1, 
          opacity: 1,
        }}
        exit={{ scale: 0, opacity: 0 }}
        transition={{ 
          type: "spring", 
          stiffness: 500, 
          damping: 25 
        }}
        className={`absolute -top-1 -right-1 flex items-center justify-center min-w-[18px] h-[18px] px-1 
                   bg-gradient-to-br from-red-500 to-red-600 
                   text-white text-[10px] font-bold rounded-full 
                   shadow-lg shadow-red-500/50
                   border-2 border-white dark:border-slate-900
                   ${className}`}
      >
        {/* Pulse animation ring */}
        <motion.div
          className="absolute inset-0 rounded-full bg-red-500"
          animate={{
            scale: [1, 1.4, 1],
            opacity: [0.8, 0, 0.8],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        
        {/* Count text */}
        <motion.span
          key={count}
          initial={{ scale: 1.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.2 }}
          className="relative z-10"
        >
          {displayCount}
        </motion.span>
      </motion.div>
    </AnimatePresence>
  );
};

export default NotificationBadge;